import { NgClass } from '@angular/common';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BehaviorsModule } from '@ddv/behaviors';
import { TextValuePair, DashboardFilter } from '@ddv/models';

import { DashboardFiltersService } from '../../../services/dashboard-filters.service';

@Component({
    selector: 'app-filterable-attribute',
    templateUrl: 'filterable-attribute.component.html',
    styleUrls: ['filterable-attribute.component.scss'],
    imports: [
        FormsModule,
        BehaviorsModule,
        NgClass,
    ],
})
export class FilterableAttributeComponent implements OnInit {
    @Output() selectAttribute = new EventEmitter<DashboardFilter>();

    searchAttributeFilter = '';
    selectedDashboardFilter: DashboardFilter = { name: '', displayName: '', criteria: 'INCLUDE', values: [] };

    protected metadataList: TextValuePair[] = [];

    constructor(public dashboardFiltersService: DashboardFiltersService) {}

    ngOnInit(): void {
        this.metadataList = this.dashboardFiltersService.getMetadataList();
    }

    onSelectAttribute(attribute: TextValuePair): void {
        this.selectedDashboardFilter.name = attribute.value;
        this.selectedDashboardFilter.displayName = attribute.text;
        this.selectedDashboardFilter.values = [];
        this.dashboardFiltersService.updateValueOptions(attribute.value);
        this.selectAttribute.emit(this.selectedDashboardFilter);
    }
}
